import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { Alert, Box, Link, Typography } from "@mui/material";

const ANTHROPOMETRY_HELP_LINKS = {
  AUTO_ONBOARD: "https://help.teamworks.com/nutrition/s/article/Share-a-Meal-Plan-Template-Through-Auto-Onboarding",
};

export const AnthropometryEntryFormAlertDisplayHeader = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Alert severity="info" icon={<InfoRoundedIcon />} sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body2Semibold">Auto-calculation</Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Fat mass and lean mass are auto-calculated from weight and % body fat, but can be manually updated by entering personal data.
          </Typography>
        </Box>
      </Alert>
      <Box sx={{ p: 2, backgroundColor: "grey.200", borderRadius: "5px" }}>
        <Typography variant="body2" color="textSecondary">
          * The anthropometry data can be filled out at a later time or collected from the athlete during{" "}
          <Link
            sx={{ color: "info.main" }}
            target="_blank"
            href={ANTHROPOMETRY_HELP_LINKS.AUTO_ONBOARD}
          >
            auto-onboarding
          </Link>
          . However,{" "}
          <Box display="inline" sx={{ fontWeight: 600 }}>
            weight is required
          </Box>{" "}
          if anthropometry data is entered.
        </Typography>
      </Box>
    </Box>
  );
};